import React from 'react'
import ImportLayout from './ImportLayout'

const Import = () => <ImportLayout />

export default Import